import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=70457b64&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70457b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70457b64')) {
      api.createRecord('70457b64', component.options)
    } else {
      api.reload('70457b64', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=70457b64&scoped=true&", function () {
      api.rerender('70457b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Error/Error.vue"
export default component.exports